import { useLocation } from 'react-router-dom'

import { NewLeavePageDocument } from 'generated/resources/graphql'
import compact from 'lodash/compact'

import { SkeletonModal } from 'modules/core/components/Modal'
import { useQuery } from 'modules/core/hooks/useQuery'

import NewLeaveModal from 'modules/timeoff/components/NewLeaveModal'
import { useOnClose } from 'modules/timeoff/hooks/useOnClose'

const NewLeavePage = () => {
  const location = useLocation()
  const leaveTypeId = new URLSearchParams(location.search).get('leave_type_id')
  const handleClose = useOnClose()
  const { loading, data } = useQuery(NewLeavePageDocument)

  if (loading) {
    return <SkeletonModal />
  }

  if (!data?.apiCore.currentsConnection.edges[0]?.node.employee) {
    throw new Error('Current employee not found')
  }

  const sickFolderId = data.documents.foldersConnection.edges[0]?.node?.id

  if (!sickFolderId) {
    throw new Error('Sick folder not found')
  }

  const currentEmployee = data.apiCore.currentsConnection.edges[0].node.employee
  const approvalGroupMemberships = data.approvals?.approvalGroupMembershipsConnection?.nodes ?? []

  const customResourceFieldsData =
    compact(
      data.documents.foldersConnection.edges[0]?.node?.resourceFieldsConnection.edges.map(
        (edge) => edge.node
      )
    ) ?? []

  return (
    <NewLeaveModal
      leaveTypeId={leaveTypeId}
      onClose={handleClose}
      currentEmployee={currentEmployee}
      leaveEmployee={currentEmployee}
      customResourceFieldsData={customResourceFieldsData}
      sickFolderId={sickFolderId}
      leaveCanManageLeaveDocuments={false}
      approvalGroupMemberships={approvalGroupMemberships}
    />
  )
}

export default NewLeavePage
